import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

export const useSiteQuery = () => {
    const {
        contentfulDigitupGlobalSite
    } = useStaticQuery(graphql`
        query {
            contentfulDigitupGlobalSite(id: {eq: "076a50fd-6e0d-5f79-a074-c2ed02fe2745"}) {
                headerLogo {
                    title
                    gatsbyImageData
                    file {
                        url
                    }
                }
                tempHeaderItems {
                    __typename
                    ...componentLink
                }
                headerButton {
                    ...componentLink
                }
                address {
                    raw
                  }
                footerCopyrightText
                footerFigCaption
                contactUsTitle
                privacyTitle
                digitupPrivacyNotice{
                    ...componentLink
                }
                privacyNoticeContent{
                    raw
                }
                
                contactUsContent {
                    raw
                }
                contactUsSuccessfulMessage {
                    raw
                }
                contactUsInterestInCategories
            }
        }
    `)
    
    return contentfulDigitupGlobalSite
}
